import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=0e7bcd82&scoped=true"
import script from "./AccordionSection.vue?vue&type=script&lang=js"
export * from "./AccordionSection.vue?vue&type=script&lang=js"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=0e7bcd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7bcd82",
  null
  
)

export default component.exports